var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnemia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.688 60.9377C109.688 51.707 107.067 42.6659 102.13 34.8661C97.1937 27.0663 90.1441 20.8284 81.8014 16.8778C73.4588 12.9273 64.166 11.4265 55.0039 12.55C45.8418 13.6735 37.1869 17.3752 30.046 23.2244C22.9051 29.0737 17.5716 36.8301 14.6659 45.5916C11.7601 54.3531 11.4016 63.7595 13.632 72.7167C15.8623 81.6739 20.5899 89.8139 27.2649 96.1897C33.9398 102.566 42.2878 106.915 51.3378 108.733L69.0625 130L76.7203 107.027C86.3328 103.738 94.6774 97.5274 100.588 89.2641C106.499 81.0008 109.68 71.0973 109.688 60.9377Z",
    fill: "#FCF05A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.25 231.562H243.75V247.812H81.25V231.562Z",
    fill: "#394D5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.375 162.5H170.625C173.857 162.5 176.957 163.784 179.243 166.07C181.528 168.355 182.812 171.455 182.812 174.688V231.562H142.188V174.688C142.188 171.455 143.472 168.355 145.757 166.07C148.043 163.784 151.143 162.5 154.375 162.5Z",
    fill: "#50B4F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.664 97.5059L121.851 85.3192L162.469 125.938L150.283 138.124L109.664 97.5059Z",
    fill: "#2D75BB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.599 117.812L117.786 105.625L142.156 129.995L129.97 142.182L105.599 117.812Z",
    fill: "#50B4F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4136 138.121L109.664 121.871L125.914 138.121L109.664 154.372L93.4136 138.121Z",
    fill: "#394D5C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M186.851 44.7051L199.04 32.5165L215.29 48.767L203.101 60.9555L186.851 44.7051Z",
    fill: "#394D5C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M190.913 24.3955L203.1 12.2088L235.596 44.7047L223.409 56.8914L190.913 24.3955Z",
    fill: "#50B4F8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.125 182.812H142.188V199.062H73.125V182.812Z",
    fill: "#394D5C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M129.977 93.4414L182.782 40.6362L207.153 65.0067L154.348 117.812L129.977 93.4414Z",
    fill: "#50B4F8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M195 77.1875L170.625 101.562H199.062C203.372 101.562 207.506 103.275 210.553 106.322C213.6 109.369 215.312 113.503 215.312 117.812V158.438C215.312 162.747 213.6 166.881 210.553 169.928C207.506 172.975 203.372 174.688 199.062 174.688H182.812V199.062H207.188C217.962 199.062 228.295 194.782 235.914 187.164C243.532 179.545 247.812 169.212 247.812 158.438V117.812C247.812 107.038 243.532 96.705 235.914 89.0863C228.295 81.4676 217.962 77.1875 207.188 77.1875H195Z",
    fill: "#2D75BB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 190.938C160.893 190.938 159.322 190.461 157.986 189.568C156.65 188.675 155.608 187.406 154.993 185.922C154.379 184.437 154.218 182.803 154.531 181.227C154.845 179.651 155.618 178.204 156.755 177.067C157.891 175.931 159.339 175.157 160.915 174.844C162.491 174.53 164.125 174.691 165.609 175.306C167.094 175.921 168.363 176.962 169.256 178.298C170.148 179.635 170.625 181.206 170.625 182.813C170.625 184.967 169.769 187.034 168.245 188.558C166.722 190.081 164.655 190.938 162.5 190.938Z",
    fill: "#FCF05A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M147.418 90.5713L163.669 74.3209L169.414 80.0661L153.164 96.3165L147.418 90.5713Z",
    fill: "#CDEEF6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M167.729 70.2637L175.853 62.1399L181.599 67.8851L173.475 76.0089L167.729 70.2637Z",
    fill: "#CDEEF6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M216.125 186.794L214.5 178.832L215.313 182.813L214.5 178.836C215.174 178.69 230.994 174.952 227.557 150.89L235.601 149.736C240.138 181.594 216.348 186.75 216.125 186.794Z",
    fill: "#4DA6EA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1759 53.113C65.11 45.183 74.3156 41.8151 77.4884 44.988L89.6759 57.1755C92.8487 60.3483 89.485 69.5579 81.5509 77.4879C73.6169 85.4179 64.4113 88.7858 61.2384 85.6129L49.0509 73.4254C45.8781 70.2526 49.2459 61.047 57.1759 53.113Z",
    fill: "#DA1C4B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M63.29 75.1565L59.1909 68.1528C61.8613 66.5626 64.3185 64.6391 66.5034 62.4287C68.715 60.2449 70.6386 57.7875 72.2275 55.1162L79.219 59.2234C77.2765 62.4878 74.9257 65.4912 72.2234 68.1609C69.552 70.8596 66.5505 73.2101 63.29 75.1565Z",
    fill: "#F98C96"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M40.625 32.5H48.75V40.625H40.625V32.5Z",
    fill: "#F9BB4B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 52.8125H32.5V60.9375H24.375V52.8125Z",
    fill: "#F9BB4B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M40.625 85.3125H48.75V93.4375H40.625V85.3125Z",
    fill: "#F9BB4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnemia);
export default __webpack_public_path__ + "static/media/Anemia.ecd6d17973cc4acbe699d518c127289e.svg";
export { ForwardRef as ReactComponent };